import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import "../styles/Profile.css";
import { Pencil } from "lucide-react";
import DeleteAccountButton from "./DeleteAccountButton";
import { useNavigate } from "react-router-dom";

const Profile: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string | null>(null);
  const [displayName, setDisplayName] = useState<string>("");
  const [newName, setNewName] = useState<string>("");
  const [editingName, setEditingName] = useState<boolean>(false);
  const [statusMessage, setStatusMessage] = useState<string>("");

  useEffect(() => {
    const fetchUserData = async () => {
      console.log("🔍 fetchUserData käynnistyi");

      const {
        data: { user },
        error: authError,
      } = await supabase.auth.getUser();

      if (authError || !user) {
        console.error("❌ Virhe käyttäjän haussa:", authError?.message);
        navigate("/");
        return;
      }

      setEmail(user.email ?? null);

      const { data, error } = await supabase
        .from("users")
        .select("display_name, created_at")
        .eq("id", user.id)
        .maybeSingle();

      if (!data || error) {
        console.warn(
          "⚠️ Käyttäjän rivi puuttuu users-taulusta tai tapahtui virhe. Uudelleenohjataan etusivulle."
        );
        navigate("/");
        return;
      }

      setDisplayName(data.display_name || "");
      setNewName(data.display_name || "");
    };

    fetchUserData();
  }, [navigate]);

  const handleNameUpdate = async () => {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    const { error } = await supabase
      .from("users")
      .update({ display_name: newName })
      .eq("id", user?.id);

    if (error) {
      console.error("Virhe nimen päivittämisessä:", error.message);
      setStatusMessage("Virhe päivitettäessä.");
    } else {
      setDisplayName(newName);
      setStatusMessage("Nimi päivitetty!");
      setEditingName(false);
    }

    setTimeout(() => setStatusMessage(""), 3000);
  };

  return (
    <div className="page-content">
      <div className="profile-container">
        <h2>Käyttäjäprofiili</h2>
        <p>
          <strong>Profiilinimi:</strong>{" "}
          {editingName ? (
            <>
              <input
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                className="name-input"
              />
              <button onClick={handleNameUpdate} className="save-button">
                Tallenna
              </button>
            </>
          ) : (
            <>
              {displayName || "Ei määritetty"}
              <button
                onClick={() => setEditingName(true)}
                className="edit-icon-button"
                aria-label="Muokkaa nimeä"
              >
                <Pencil size={16} />
              </button>
            </>
          )}
        </p>
        <p>
          <strong>Sähköposti:</strong> {email ?? "Ei saatavilla"}
        </p>

        {statusMessage && <p className="status-message">{statusMessage}</p>}
        <DeleteAccountButton />
      </div>
    </div>
  );
};

export default Profile;
